import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetItemComponentBase } from 'src/app/services/sheets-renderer.service';
import { Row } from 'src/app/types/aggregate-graph.types';
import { IvtfSupplementationInstructionsV2 } from 'src/app/types/sheet-instruction.types';
import { InstructionBoxComponent } from '../../instruction-box/instruction-box.component';
import { ItemContentComponent } from '../../item-content/item-content.component';

@Component({
    selector: 'app-ivtf-supplementation-item-v2',
    templateUrl: './ivtf-supplementation-item-v2.component.html',
    styleUrl: './ivtf-supplementation-item-v2.component.scss',
    imports: [ItemContentComponent, InstructionBoxComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IvtfSupplementationItemComponentV2 implements SheetItemComponentBase {

	row!: Row;
	instructions!: IvtfSupplementationInstructionsV2;
	@Input() startLabel!: string;
	@Input() endLabel!: string;
	@Input('row') set updateRow(row: Row) {
		this.row = row;
		this.instructions = row.instructions as IvtfSupplementationInstructionsV2;
	}

	constructor() {
	}
}